import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { COLORS } from "config/theme/baseTheme";
import { fontWeight } from "styled-system";
import { color } from "styled-system";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    continueBtn: {
      width: "100%",
      color: COLORS.WHITE,
      borderRadius: "5px",
      border: "none",
      cursor: "pointer",
      margin: "12px 0",
      background: COLORS.PRIMARY_MAIN,
      '&:hover': {
        backgroundColor: COLORS.PRIMARY_MAIN, // Prevent background color change
        textDecoration: 'none', // Prevent text decoration
      },
    },
    scannerContainer: {
      "& .heading": {
        fontSize: "16px",
        color: COLORS.BLACK,
        fontWeight: 600,
      },
      "& .subHeading": {
        fontSize: "14px",
        color: COLORS.BLACK,
        fontWeight: 400
      },
      "& .scanner": {
        textAlign: "center",
      },
      "& img": {
        width: "auto",
        height: "auto",
        maxWidth: "250px", // Set maximum width
        maxHeight: "250px", // Set maximum height
      },
    },
    messageContainer: {
      "& .heading": {
        fontSize: "16px",
        color: COLORS.BLACK,
        fontWeight: 600,
        marginBottom: "12px",
      },
      "& .subHeading": {
        fontSize: "14px",
        color: COLORS.BLACK,
        marginBottom: "14px",
        fontWeight: 400
      },
      "& .image": {
        width: "auto",
        height: "auto",
      },
      "& .icon": {
        marginBottom: "12px",
        marginRight: "4px",
      },
    },
    successMessage: {},
    errorMessage: {
      "& .heading": {
        color: COLORS.CRAB_APPLE,
      },
      "& .subHeading": {
        color: COLORS.CRAB_APPLE,
      },
      "& .resendCode": {
        textTransform: 'none',
        padding: 0, 
        minWidth: 'auto',
        color:COLORS.PERSIAN_BLUE,
        textDecoration: 'underline',
        fontWeight: 400
      }
    },
  })
);
